<style lang="scss">
  @import '../resources/scss/project_type1_last_section.scss';
</style>

<script lang="ts">
  import type ProjectLastSectionFirstType from '../api/rest/directus-cms/projects/model/ProjectLastSectionFirstType'

  export let lastSection: ProjectLastSectionFirstType
</script>

<div class="container-fluid bg-white">
  <div class="row gl-0">
    <div
      class="col-12 col-lg-6 last-section-image"
      style="background-image: url({lastSection.top_left_image?.fullUrl});"
    />
    <div class="col-12 col-lg-6">
      <div class="container-xxl text-container">
        <h4 class="mb-0">
          {@html lastSection.translations[0]?.work_details}
        </h4>
      </div>
    </div>
  </div>
</div>
